import { render, staticRenderFns } from "./ViewVariants.vue?vue&type=template&id=2c3e218e&scoped=true"
import script from "./ViewVariants.vue?vue&type=script&lang=js"
export * from "./ViewVariants.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=2c3e218e&prod&scoped=true&lang=css&external"
import style1 from "./ViewVariants.vue?vue&type=style&index=1&id=2c3e218e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e218e",
  null
  
)

export default component.exports